import { useState } from "react";

const quickReplies = [
  "AC service price",
  "AC gas filling",
  "Booking time",
  "Location",
  "Phone number",
];

const getBotReply = (text) => {
  const message = text.toLowerCase();

  if (message.includes("price") || message.includes("cost")) {
    return "Price depends on issue and model. Share your appliance details and we will give a clear estimate before work.";
  }

  if (message.includes("gas")) {
    return "AC gas filling includes pressure check, leak test, and final cooling test. We provide safe and proper gas charging.";
  }

  if (message.includes("book") || message.includes("time") || message.includes("visit")) {
    return "You can book now. Our team usually confirms a visit within minutes and provides same-day support.";
  }

  if (message.includes("location") || message.includes("address")) {
    return "We are near middle school, Station Road, Masrakh, Saran, Bihar.";
  }

  if (message.includes("phone") || message.includes("call") || message.includes("contact")) {
    return "Call us at +91 7319963740 or +91 6204283487. You can also submit the form and we will contact you.";
  }

  return "I can help with AC service, gas filling, booking, location, and contact details. Type your question or use quick options below.";
};

function ChatbotWidget() {
  const [isOpen, setIsOpen] = useState(false);
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([
    {
      role: "bot",
      text: "Hi, welcome to GURU KRIPA. Ask me about AC service, gas filling, booking time, or location.",
    },
  ]);

  const sendMessage = (text) => {
    const trimmed = text.trim();
    if (!trimmed) return;

    setMessages((prev) => [...prev, { role: "user", text: trimmed }]);
    const reply = getBotReply(trimmed);
    setMessages((prev) => [...prev, { role: "bot", text: reply }]);
    setInput("");
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    sendMessage(input);
  };

  return (
    <div className="chatbot-wrap">
      {isOpen && (
        <section id="chatbot-panel" className="chatbot-panel" aria-label="Chat support">
          <div className="chatbot-head">
            <h3>Quick Help Chat</h3>
            <button
              type="button"
              className="chatbot-close"
              onClick={() => setIsOpen(false)}
              aria-label="Close chatbot"
            >
              x
            </button>
          </div>

          <div className="chatbot-messages">
            {messages.map((message, index) => (
              <div
                key={`${message.role}-${index}`}
                className={`chat-msg ${message.role === "user" ? "user" : "bot"}`}
              >
                {message.text}
              </div>
            ))}
          </div>

          <div className="chatbot-quick">
            {quickReplies.map((item) => (
              <button
                type="button"
                key={item}
                className="quick-btn"
                onClick={() => sendMessage(item)}
              >
                {item}
              </button>
            ))}
          </div>

          <form className="chatbot-form" onSubmit={handleSubmit}>
            <input
              type="text"
              value={input}
              onChange={(event) => setInput(event.target.value)}
              placeholder="Type your question..."
            />
            <button type="submit">Send</button>
          </form>
        </section>
      )}

      <button
        type="button"
        className="chatbot-toggle"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-expanded={isOpen}
        aria-controls="chatbot-panel"
      >
        <img
          src={`${process.env.PUBLIC_URL}/bot-icon.svg`}
          alt=""
          aria-hidden="true"
          className="chatbot-toggle-icon"
        />
        <span>{isOpen ? "Close Chat" : "Chat With Us"}</span>
      </button>
    </div>
  );
}

export default ChatbotWidget;
